module.exports = __webpack_public_path__ + "static/img/catalogMore1.768a1df8.svg";